export const PLATFORM_BUTTON_ANALYTICS_ATTRIBUTES = {
    location: 'page',
    category: {
        linkapp: 'linkapp',
        interaction: 'interaction'
    }
};
